import React from 'react'

const EmptyContent = ({ title }: { title: string }) => (
  <div className="flex flex-col items-center justify-center w-full h-24">
    <div className="text-gray-500 text-lg">{title}</div>
  </div>
)

export default EmptyContent
